import { render, staticRenderFns } from "./SignUpComponent.vue?vue&type=template&id=e09c9110&scoped=true&"
import script from "./SignUpComponent.vue?vue&type=script&lang=ts&"
export * from "./SignUpComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SignUpComponent.vue?vue&type=style&index=0&id=e09c9110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09c9110",
  null
  
)

export default component.exports